
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/capabilities/latest-mentions",
      function () {
        return require("private-next-pages/capabilities/latest-mentions.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/capabilities/latest-mentions"])
      });
    }
  